import { accessContentHubActivity, accessContentHubGalleries, accessContentHubGallery, accessContentHubGalleryMedia, accessContentHubMyContent } from '@/permissions/contentHub';
import { useUserStore } from '@/stores/userStore';
import type { RouteRecordRaw } from 'vue-router';
import { FEATURE_FLAGS } from '@teamworksdev/influencer/core';

const routes: RouteRecordRaw[] = [
	{
		path: '/content-hub',
		component: () => import('@/views/ContentHubParent.vue'),
		children: [
			{
				path: '',
				name: 'ContentHubIndex',
				redirect: () => {
					const userStore = useUserStore();
					return userStore.profileAccess.canAccessContentHubRead ? { name: 'ContentHubGalleries' } : { name: 'ContentHubMyContent' };
				},
			},
			{
				path: 'galleries',
				name: 'ContentHubGalleries',
				component: () => import('@/views/ContentHubGalleries.vue'),
				meta: {
					requiresAuth: true,
					layout: 'LayoutAuthenticated',
					title: 'pageContentHubGalleries.metaTitle',
					permissionRule: accessContentHubGalleries,
				},
			},
			{
				path: 'galleries/:galleryId',
				name: 'ContentHubGallery',
				component: () => import('@/views/ContentHubGallery.vue'),
				props: true,
				meta: {
					requiresAuth: true,
					layout: 'LayoutAuthenticated',
					title: 'pageContentHubGallery.metaTitle',
					permissionRule: accessContentHubGallery,
					profileSwitchRedirect: 'ContentHubIndex',
				},
			},
			{
				path: 'galleries/:galleryId/upload',
				name: 'ContentHubGalleryUpload',
				component: () => import('@/views/ContentHubGalleryUpload.vue'),
				props: true,
				meta: {
					requiresAuth: true,
					layout: 'LayoutAuthenticated',
					title: 'pageContentHubGalleryUpload.metaTitle',
					requiredAccess: 'hasContentHubWrite',
					profileSwitchRedirect: 'ContentHubIndex',
				},
			},
			{
				path: 'galleries/:galleryId/media/:mediaId',
				name: 'ContentHubSingleMedia',
				component: () => import('@/views/ContentHubSingleMedia.vue'),
				props: true,
				meta: {
					requiresAuth: true,
					layout: 'LayoutAuthenticated',
					title: 'pageContentHubSingleMedia.metaTitle',
					permissionRule: accessContentHubGalleryMedia,
					profileSwitchRedirect: 'ContentHubIndex',
				},
			},
			{
				path: 'my-content',
				name: 'ContentHubMyContent',
				component: () => import('@/views/ContentHubMyContent.vue'),
				meta: {
					requiresAuth: true,
					layout: 'LayoutAuthenticated',
					title: 'pageContentHubMyContent.metaTitle',
					permissionRule: accessContentHubMyContent,
				},
			},
			{
				path: 'media',
				name: 'ContentHubMedia',
				component: () => import('@/views/ContentHubMedia.vue'),
				meta: {
					requiresAuth: true,
					layout: 'LayoutAuthenticated',
					title: 'pageContentHubMedia.metaTitle',
					requiredAccess: 'canAccessContentHubRead',
					hideTabsNavigation: true,
				},
			},
			{
				path: 'activity',
				name: 'ContentHubActivity',
				component: () => import('@/views/ContentHubActivity.vue'),
				meta: {
					requiresAuth: true,
					layout: 'LayoutAuthenticated',
					title: 'pageContentHubActivity.metaTitle',
					permissionRule: accessContentHubActivity,
					requiredLDFlags: [FEATURE_FLAGS.CONTENT_HUB_ACTIVITY_ENABLED],
				},
			},
			{
				path: 'content-keywords',
				name: 'ContentHubContentKeywords',
				component: () => import('@/views/ContentHubContentKeywords.vue'),
				meta: {
					requiresAuth: true,
					layout: 'LayoutAuthenticated',
					title: 'pageContentHubContentKeywords.metaTitle',
					requiredAccess: 'hasContentHubWrite',
				},
			},
			{
				path: 'content-keywords/:contentKeyword',
				name: 'ContentHubContentKeyword',
				component: () => import('@/views/ContentHubContentKeyword.vue'),
				props: true,
				meta: {
					requiresAuth: true,
					layout: 'LayoutAuthenticated',
					title: 'pageContentHubContentKeyword.metaTitle',
					requiredAccess: 'hasContentHubWrite',
				},
			},
			{
				path: 'reactions',
				name: 'ContentHubReactions',
				component: () => import('@/views/ContentHubReactions.vue'),
				meta: {
					requiredAccess: 'hasContentHubWrite',
					layout: 'LayoutAuthenticated',
					requiredLDFlags: [FEATURE_FLAGS.REACTIONS_ENABLED],
					requiresAuth: true,
					title: 'pageContentHubReactions.metaTitle',
				},
			},
		],
	},
	{
		path: '/content-hub/dashboard',
		name: 'ContentHubDashboard',
		component: () => import('@/views/ContentHubDashboard.vue'),
		meta: {
			requiresAuth: true,
			layout: 'LayoutAuthenticated',
			requiredAccess: 'hasContentHubWrite',
			title: 'pageContentHubDashboard.metaTitle',
		},
	},
];

export default routes;
